"use strict";

exports.__esModule = true;
exports.CircleSelected = CircleSelected;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function CircleSelected(props) {
  return _react["default"].createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    transform: "translate(1 1)"
  }, _react["default"].createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), _react["default"].createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5,
    fill: "currentColor",
    strokeWidth: 5
  })));
}